import { ConnectedServiceAttestation } from './types'
import { FormMetadata } from '../../models'
import { extendMetadata } from '../assignments/utils'

export const extendConnectedServiceAttestationMetadata = ({
  connectedServiceAttestation,
  metadata,
  baseInputStyle,
  checkboxProps,
}: {
  connectedServiceAttestation: ConnectedServiceAttestation
  metadata: FormMetadata
  checkboxProps?: Dict
  baseInputStyle?: React.CSSProperties
}) => {
  return extendMetadata(metadata, {
    schema: {
      properties: {
        connectedServiceAttestation: {
          name: 'connectedServiceAttestation',
          title: connectedServiceAttestation.attestationText,
          type: 'boolean',
          ...(checkboxProps && { widgetProps: checkboxProps }),
        },
      },
    },
    uiSchema: {
      'ui:order': ['connectedServiceAttestation'],
      connectedServiceAttestation: {
        'ui:widget': 'checkbox',
        'ui:options': {
          baseInputStyle: {
            marginBottom: 0,
            ...(baseInputStyle ?? {}),
          },
        },
      },
    },
  })
}
